export default {
  customersNew: {
    isLoading: false,
    data: [],
    count: 0,
    status: null,
    error: false,
    errorMessage: null
  },
  customerNew: {
    isLoading: false,
    data: {},
    status: null,
    error: false,
    errorMessage: null
  },
};
